import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index.js";
import Cookies from "js-cookie";
import stockRoutes from "@/router/stock.js";
import screenerRoutes from "@/router/screener.js";
import accountCenterRoutes from "@/router/accountCenter.js";
import userCenterRoutes from "@/router/userCenter.js";
import statisticsRoutes from "@/router/statistics.js";
import newlyAdded from "@/router/newlyAdded.js";
import websiteDescriptions from "@/router/websiteDescriptions.js";

Vue.use(Router);

// https://github.com/vuejs/vue-router/issues/2881
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

const indexRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue")
  },
  {
    path: "/account/check",
    name: "accountCheck",
    component: () => import("@/views/AccountCheck.vue")
  },
  {
    path: "/password/reset/:verifyInfo",
    name: "passwordReset",
    component: () => import("@/views/PasswordReset.vue"),
    beforeEnter: async (to, from, next) => {
      store.commit("verifyAccountToken", to.params.verifyInfo);
      store.commit("verifyAccountEmail", to.query.email);
      console.log(">>>> 從忘記密碼通知信來", to.params.verifyInfo);
      console.log(">>>> 從忘記密碼通知信來", to.query);
      next();
    }
  },
  {
    path: "/password/set/:verifyInfo",
    name: "passwordSet",
    component: () => import("@/views/PasswordSet.vue"),
    beforeEnter: async (to, from, next) => {
      store.commit("verifyNewAccountToken", to.params.verifyInfo);
      store.commit("verifyNewAccountEmail", to.query.email);
      console.log(">>>> 從通知信來", to.params.verifyInfo);
      console.log(">>>> 從通知信來", to.query);
      next();
    }
  },
  { path: "*", redirect: { name: "login" } }
];

const router = new Router({
  mode: "history",
  routes: [
    ...stockRoutes,
    ...screenerRoutes,
    ...accountCenterRoutes,
    ...userCenterRoutes,
    ...statisticsRoutes,
    ...newlyAdded,
    ...websiteDescriptions,
    ...indexRoutes
  ]
});

router.beforeEach(async (to, from, next) => {
  //檢查是否有 token
  const loggedIn = Cookies.get("chuenStock");

  //所去頁面需要 token 且 token 不存在
  if (to.meta.requiresAuth && !loggedIn) {
    //導向登入頁
    next({ name: "login" });
  }
  //所去頁面不需要 token 且 token 存在
  else if (!to.meta.requiresAuth && loggedIn) {
    //登出清除 token
    store.commit("logout");

    next();
  }
  //所去頁面需要 token
  else if (to.meta.requiresAuth) {
    try {
      //測試 user 身份是否在黑名單中，若在黑名單中 api 會 401 error
      await store.dispatch("fetchPriceToEarningRatio");
      next();
    } catch (e) {
      //登出清除 token
      store.commit("logout");

      //導向登入頁
      next({ name: "login" });
    }
  } else {
    next();
  }
});

export default router;
